import { Button, Stack, styled, Typography } from '@mui/material';
import { Banner } from 'features/navigation';
import { loadOffersThunk } from 'pages/candidateOfferList/store/candidateOfferListSlice';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from 'shared/constants';
import { useAccessFilterCheck, useAppDispatch } from 'shared/hooks';

export default function AdditionalNavigationBanner() {
    const { t } = useTranslation('candidateOffers');
    const jobPreferencesEnabled = useAccessFilterCheck({ feature: 'CandidatesJobPreferences' });

    return (
        <Banner>
            <Root>
                <Typography gutterBottom
                    variant="body1"
                >
                    { t('overview.notFindingWhatYouAreLookingFor') }
                </Typography>
                <ButtonsContainer>
                    { jobPreferencesEnabled 
                        ? <UpdateJobPreferencesButton />
                        : <AskForMoreOpportunitiesButton /> }
                    <RefreshButton />
                </ButtonsContainer>
            </Root>
        </Banner>
    );
}

function RefreshButton() {
    const { t } = useTranslation('candidateOffers');
    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(loadOffersThunk({ pageNumber: 1 }));
    };

    return (
        <Button variant="outlined"
            onClick={ handleClick }
        >
            { t('overview.refresh') }
        </Button>
    );
}

function UpdateJobPreferencesButton() {
    const { t } = useTranslation('candidateOffers');
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(APP_ROUTES.preferences);
    };
    
    return (
        <Button variant="contained"
            color="secondary"
            onClick={ handleClick }
        >
            { t('overview.updateJobPreferences') }
        </Button>
    );
}

function AskForMoreOpportunitiesButton() {
    const { t } = useTranslation('candidateOffers');
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(APP_ROUTES.requestForOpportunities);
    };
    
    return (
        <Button variant="contained"
            color="secondary"
            onClick={ handleClick }
        >
            { t('overview.askForMoreOpportunities') }
        </Button>
    );
}

const Root = styled(Stack)(({ theme }) => ({
    padding: theme.spacing(5)
}));

const ButtonsContainer = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    gap: theme.spacing(3),
    justifyContent: 'stretch',
    flexWrap: 'wrap',

    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column'
    }
}));
